var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.time)?_c('span',[_vm._v(_vm._s(_vm._f("time")(_vm.time,_vm.format)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }